// Unpublished Work © 2026 Deere & Company.

import {handleResponse} from '../../common/utils/response';
import {OrganizationId} from '../models/organization';

export type SelectedOrganization = {
    id: OrganizationId;
    name: string;
    key: string;
    parentId: string | null;
    isMember: boolean;
};

export type OrganizationClassification = {
    categoryId: number;
    focusId: number;
};

export type SelectedOrganizationsResponse = {
    selectedOrganizations: SelectedOrganization[];
    organizationClassification: OrganizationClassification;
};

export const getSelectedOrganizations = async (
    abortSignal?: AbortSignal,
): Promise<SelectedOrganizationsResponse> => {
    const url = '/users/selected-organizations';
    const response = await fetch(url, {
        signal: abortSignal,
    });

    return await handleResponse<SelectedOrganizationsResponse>(response);
};
